<rt-group variant="horizontal stacked">
  <rt-icon-button
    [disabled]="!canGoToPrevPage"
    (click)="pageChange.emit(page() - 1)"
    variant="tertiary"
    iconName="keyboard-arrow-left"
    shape="square"
  />

  <rt-icon-button
    [disabled]="!canGoToNextPage"
    (click)="pageChange.emit(page() + 1)"
    variant="tertiary"
    iconName="keyboard-arrow-right"
    shape="square"
  />
</rt-group>
